import React from 'react';

const PaypalIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.58" d="M20 0H0V20H20V0Z" fill="white" />
    <path
      d="M15.8333 5.83317C15.8333 5.98317 15.825 6.12484 15.8083 6.26651C15.7083 7.47484 15.175 8.56651 14.3667 9.36651C13.4667 10.2748 12.2167 10.8332 10.8333 10.8332H8.22501C7.80834 10.8332 7.45835 11.1415 7.40002 11.5498L6.76668 15.9498C6.71668 16.2748 6.48335 16.5415 6.17502 16.6248C6.10002 16.6582 6.02502 16.6665 5.94168 16.6665H4.31667C3.80001 16.6665 3.40835 16.2082 3.49168 15.6998L5.48334 3.75817C5.68334 2.54983 6.72502 1.6665 7.95002 1.6665H11.6667C13.9667 1.6665 15.8333 3.53317 15.8333 5.83317Z"
      fill="#12B76A"
    />
    <path
      opacity="0.4"
      d="M17.4999 9.1666C17.4999 10.3166 17.0332 11.3583 16.2832 12.1166C15.5249 12.8666 14.4832 13.3333 13.3332 13.3333H11.5416C11.1332 13.3333 10.7832 13.6249 10.7166 14.0333L10.1166 17.6333C10.0499 18.0416 9.6999 18.3333 9.29157 18.3333H6.84991C6.32491 18.3333 5.93323 17.8499 6.03323 17.3333L6.17491 16.6249C6.48324 16.5416 6.71657 16.2749 6.76657 15.9499L7.39991 11.5499C7.45824 11.1416 7.80824 10.8333 8.2249 10.8333H10.8332C12.2166 10.8333 13.4666 10.2749 14.3666 9.3666C15.1749 8.5666 15.7082 7.47493 15.8082 6.2666C16.8166 6.8416 17.4999 7.92493 17.4999 9.1666Z"
      fill="#12B76A"
    />
  </svg>
);

export default PaypalIcon;
